import React from 'react';
import './StatCard.css';

/**
 * StatCard – KPI metric tile
 * @param {string} variant - '' | 'gold' | 'sky' | 'red'
 */
export default function StatCard({ label, value, unit, change, up, icon, variant = '' }) {
  return (
    <div className={`stat-card ${variant ? `stat-card--${variant}` : ''}`}>
      <span className="stat-card__icon">{icon}</span>
      <div className="stat-card__label">{label}</div>
      <div className="stat-card__value">
        {value}
        {unit && <span className="stat-card__unit">{unit}</span>}
      </div>
      {change && (
        <div className={`stat-card__change ${up ? 'stat-card__change--up' : 'stat-card__change--down'}`}>
          {up ? '▲' : '▼'} {change}
        </div>
      )}
    </div>
  );
}
